import { useState, useEffect, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Dropdown from '../../Atoms/Dropdown';
import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import FormVacationSearch from '../../Molecules/FormVacationSearch';
import CardVacancyExt from '../../Molecules/CardVacancyExt';
import BannerCV from '../../Organisms/BannerCV';
import Pagination from '../../Molecules/Pagination';
import Button from '../../Atoms/Button';
import AccordionFilters from '../../Molecules/AccordionFilters';
import Checkbox from '../../Atoms/Checkbox';
import InputCombo from '../../Atoms/InputCombo';
import RangeDistance from '../../Molecules/RangeDistance';
import CardDefault from '../../Molecules/CardDefault';
import Image from '../../Atoms/Image';
import bgDecor from '../../../assets/img/our-canidat-decor.png';

function FilterBar() {
  return (
    <>
      <div className="mb-14 flex flex-wrap items-center justify-between gap-4">
        <Title as="h3" size={5} color="blue">
          <span className="text-xl lg:text-2xl">
            Filters
          </span>
        </Title>
        <Button
          text="Verwijder alle"
          color="primary"
          disabled
          iconName="x-mark"
        />
      </div>
      <AccordionFilters
        className="mb-8"
        elements={[
          {
            title: 'Afstand',
            content: (
              <div className="flex flex-col gap-y-8">
                <InputCombo placeholder="Postcode of plaats" />
                <RangeDistance />
                <Button
                  text="Reset invoer"
                  fluid
                  disabled
                  color="primary"
                  iconName="rotate-right"
                />
              </div>
            ),
            isOpened: true
          },
          {
            title: 'Specialismen',
            content: (
              <div className="flex flex-col gap-y-5">
                <Checkbox defaultChecked fluid reverse>
                  (Internationaal) Service Monteurs
                </Checkbox>
                <Checkbox fluid reverse>
                  Mechanical Engineers
                </Checkbox>
                <Checkbox fluid reverse>
                  Mechanical Engineers
                </Checkbox>

                <Checkbox fluid reverse>
                  Mechanical Engineers
                </Checkbox>
              </div>
            ),
            selection: [
              'Mechanical Engineers',
              'Mechanical Engineers',
              'Mechanical Engineers'
            ],
            isOpened: true
          },
          {
            title: 'Opleidingsrichting',
            content: (
              <div className="flex flex-col gap-y-5">
                <Checkbox fluid reverse>
                  (Internationaal) Service Monteurs
                </Checkbox>
                <Checkbox fluid reverse>
                  Mechanical Engineers
                </Checkbox>
                <Checkbox fluid reverse defaultChecked>
                  Mechanical Engineers
                </Checkbox>

                <Checkbox fluid reverse>
                  Mechanical Engineers
                </Checkbox>
              </div>
            ),
            isOpened: true
          }
        ]}
      />
    </>
  );
}

function Careers() {
  const [filterModalIsOpen, setFilterModalIsOpen] =
    useState(false);

  const openModal = () => setFilterModalIsOpen(true);

  const closeModal = () => setFilterModalIsOpen(false);
  useEffect(() => {
    window.addEventListener('resize', closeModal);

    return () => {
      window.removeEventListener('resize', closeModal);
    };
  }, []);

  return (
    <>
      <section
        className="relative z-[1] rounded-b-xl px-7 pt-20 pb-6 sm:pt-24"
        style={{
          background:
            'linear-gradient(225deg, #6E77F8 0%, #606AF8 100%)'
        }}
      >
        <div className="mx-auto max-w-3xl text-center">
          <div className="mx-auto mb-8 max-w-2xl lg:max-w-none">
            <Title
              as="h1"
              size={3}
              color="white"
              weight={400}
              leading="tight"
            >
              De beste banen in de machinebouw,
              (proces)industrie en industriële
              automatisering.
            </Title>
          </div>
          <FormVacationSearch />
        </div>
      </section>
      <section className="py-16">
        <div className="mx-auto w-full max-w-7xl px-7">
          <div className="flex flex-row-reverse">
            <div className="flex-1">
              {/* mobile filter button */}
              <div className="fixed bottom-0 left-0 z-[20] flex h-[90px] w-full items-end justify-center bg-gradient-to-t from-white to-transparent p-5 md:h-[140px] lg:hidden">
                <Button
                  text="Filter"
                  shadow
                  iconName="filter"
                  color="primary"
                  onClick={openModal}
                />
              </div>
              {/* end of mobile filter button */}
              <header className="mb-14 flex flex-wrap items-center justify-between gap-x-14 gap-y-5">
                <Text
                  size="lg"
                  font="circular"
                  color="blue-dark"
                >
                  <span>
                    <span className="font-bold">5424</span>{' '}
                    resultaten
                  </span>
                </Text>
                <div className="hidden xsm:inline-flex">
                  <Dropdown
                    data={[
                      {
                        id: '1',
                        label: 'Standaard',
                        value: 'value 1'
                      },
                      {
                        id: '2',
                        label: 'Nieuwste',
                        value: 'value 2'
                      },
                      {
                        id: '3',
                        label: 'Meest bekeken',
                        value: 'value 3'
                      }
                    ]}
                    width={254}
                    prefix="Sorteer op: "
                  />
                </div>
                <div className="shrink-0 grow basis-[160px] xsm:hidden">
                  <Dropdown
                    data={[
                      {
                        id: '1',
                        label: 'Standaard',
                        value: 'value 1'
                      },
                      {
                        id: '2',
                        label: 'Nieuwste',
                        value: 'value 2'
                      },
                      {
                        id: '3',
                        label: 'Meest bekeken',
                        value: 'value 3'
                      }
                    ]}
                  />
                </div>
              </header>
              <div className="mb-9 flex flex-col gap-y-8">
                <CardVacancyExt
                  title="Junior Recruiting Consultant"
                  description="Wil jij je eigen salaris bepalen, werken in een high-class sales omgeving met de leukste collega’s en deals sluiten met de groots Wil jij je eigen salaris bepalen, werken in een high-class sales omgeving met de leukste collega’s en deals sluiten met de groots"
                  link="#!"
                  linkDirectApply="#!!"
                  badges={[
                    {
                      text: 'Net binnen!',
                      size: 'sm',
                      color: 'red'
                    }
                  ]}
                  tags={[
                    {
                      icon: 'award',
                      text: 'HBO / WO'
                    },
                    {
                      icon: 'location',
                      text: 'Apeldoorn'
                    },
                    {
                      icon: 'euro',
                      text: '2.300'
                    }
                  ]}
                />
                <CardVacancyExt
                  title="Junior Recruiting Consultant"
                  description="Wil jij je eigen salaris bepalen, werken in een high-class sales omgeving met de leukste collega’s en deals sluiten met de groots Wil jij je eigen salaris bepalen, werken in een high-class sales omgeving met de leukste collega’s en deals sluiten met de groots"
                  link="#!"
                  linkDirectApply="#!!"
                  tags={[
                    {
                      icon: 'award',
                      text: 'HBO / WO'
                    },
                    {
                      icon: 'euro',
                      text: '2.300 - 4.822'
                    }
                  ]}
                />
                <BannerCV inline />
                <CardVacancyExt
                  title="Junior Recruiting Consultant"
                  description="Wil jij je eigen salaris bepalen, werken in een high-class sales omgeving met de leukste collega’s en deals sluiten met de groots Wil jij je eigen salaris bepalen, werken in een high-class sales omgeving met de leukste collega’s en deals sluiten met de groots"
                  link="#!"
                  linkDirectApply="#!!"
                  tags={[
                    {
                      icon: 'award',
                      text: 'HBO / WO'
                    },
                    {
                      icon: 'euro',
                      text: '2.300 - 4.822'
                    }
                  ]}
                />
              </div>
              <Pagination className="flex-wrap" />
            </div>
            {/* mobile filter modal */}
            <Transition appear show={filterModalIsOpen}>
              <Dialog onClose={openModal}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 z-[100] bg-white" />
                </Transition.Child>
                <div className="fixed inset-0 z-[150] overflow-y-auto">
                  <div className="flex min-h-full">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Dialog.Panel className="relative flex w-full px-7 py-10">
                        <div className="flex flex-1 flex-col">
                          <FilterBar />
                          <div className="mt-auto">
                            <Button
                              text="Toon 14 resultaten"
                              fluid
                              color="primary"
                              onClick={() => closeModal()}
                            />
                          </div>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition>
            {/* end of mobile filter modal */}
            <aside className="mr-[10%] hidden shrink-0 basis-72 lg:block">
              <FilterBar />
            </aside>
          </div>
        </div>
      </section>
      <div className="relative bg-white py-10 lg:pt-32 lg:pb-56">
        <div className="relative z-10 mx-auto w-full max-w-7xl px-7">
          <Title
            as="h2"
            className="mb-10 text-center lg:mb-20"
          >
            Jij weet wat je wil en wij weten waar je dat kan
            doen.
          </Title>
          <div className="grid items-stretch gap-5 md:grid-cols-2 lg:gap-7">
            <CardDefault
              title="Upload je cv en level up!"
              text="We brengen alle opties in de markt voor je in kaart. Aan jou de keuze."
              button={{
                href: '#!',
                text: 'Deel jouw cv',
                iconName: 'file-user'
              }}
              color="blue"
            />
            <CardDefault
              title="Level up your job"
              text="Gebruik onze carriére tool om te bepalen welke uitdagingen passen bij jouw voorkeuren. En ontdek ons uitgebreide vacature aanbod."
              button={{
                href: '#!',
                text: 'Ontdek jouw kansen',
                iconName: 'arrow-right'
              }}
              color="gray"
            />
          </div>
        </div>
        <div className="pointer-events-none absolute inset-0 z-0 hidden 2xl:block">
          <Image
            src={bgDecor}
            alt="description"
            className="h-full w-full object-cover lg:object-fill"
          />
        </div>
      </div>
    </>
  );
}

export default Careers;
